import { cardSchemesConstants } from "../constants/action.constants";

const initialState = {
  fetching: false,
  fetched: false,
  response: null,
  error: null
};

export const cardSchemes = (state = initialState, action) => {
  switch (action.type) {
    case cardSchemesConstants.GET_CARDSCHEMES_REQUEST:
      return {
        ...state,
        fetching: true
      };
    case cardSchemesConstants.GET_CARDSCHEMES_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        response: action.response,
        error: null
      };
    case cardSchemesConstants.GET_CARDSCHEMES_FAILURE:
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: action.error
      };
    case cardSchemesConstants.GET_CARDSCHEMES_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
